module.exports = __webpack_public_path__ + "static/img/ys2.aa9796e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ys2.png
// module id = fsM7
// module chunks = 1